import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import TextSection from "../template/TextSection";
import KpsEditor from "../editor/KpsEditor";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { Trans } from "react-i18next";
import DisplayDecisionTree from "../tree/DisplayDecisionTree";
import Dialog from "@material-ui/core/Dialog";
import EditDecisionTree from "./EditDecisionTree";
import { CardActions } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorIcon from "@material-ui/icons/Error";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
const styles = (theme) => ({
  error: {
    color: theme.palette.error.light,
  },
});
class ContentSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invisible: false,
      editing: false,
      edit: false,
      editChange: false,
      tempText: "",
      attachmentIds: [],
      prevText: "",
      initialContent: "",
      incomplete: false,
      unsaved: false,
    };
  }

  // Sets a flag used to suppress unwanted effects of the change event which is fired
  // when the data is added to the editor, rather than when the editor has made a change.
  supressed = false;
  suppressFor_ms(ms) {
    var self = this;
    self.supressed = true;
    setTimeout(function() {
      self.supressed = false;
    }, ms);
  }

  componentDidMount() {
    this.setState({
      initialContent: this.props.section.defaultText,
      tempText: this.props.section.defaultText,
    });
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.edit) {
  //     this.setState({ initialContent: this.props.section.defaultText })
  //   }
  // }
  setUnsaved(unsaved, section) {
    if (this.props.setUnsaved) {
      this.props.setUnsaved(unsaved, section);
    }
    this.setState({ unsaved: unsaved });
  }

  updateSection(section) {
    if (this.props.updateSection) {
      this.props.updateSection(section);
    }
    if (!this.supressed && !this.props.section.reusableSectionId) {
      this.setUnsaved(true, section.sectionID);
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div
        aria-label="Content section"
        // style={{
        //   display:
        //     this.props.editId != null &&
        //     this.props.editId != this.props.section.id &&
        //     "none",
        // }}
      >
        <CardHeader
          {...this.props.dragHandleProps}
          title={<div>{this.props.section.name}</div>}
          avatar={
            this.props.section.invisible ? (
              <VisibilityOffIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
            ) : null
          }
          action={
            <>
              {this.props.section.canMove && (
                <>
                  <Tooltip title={"Remove"} aria-label={"Remove"}>
                    <IconButton
                      onClick={() => this.props.remove(this.props.section)}
                    >
                      <CloseIcon className={classes.button} />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              {this.state.incomplete && (
                <Tooltip
                  title={"Decision tree incomplete"}
                  aria-label={"Decision tree incomplete"}
                >
                  <ErrorIcon className={classes.error} />
                </Tooltip>
              )}
            </>
          }
        />
        <CardContent>
          {this.props.section.type !== "tree" ? (
            <div>
              {!this.state.editing ? (
                <div
                  style={{
                    border: "1px dotted rgba(0,0,0,0.3)",
                    cursor: "text",
                    padding: "20px 10px",
                    borderRadius: 2,
                  }}
                  className="edit-container"
                  onClick={this.startEdit}
                  tabindex={0}
                  aria-label="Click here to open the text editor"
                >
                  <TextSection
                    contentCreation
                    onChange={this.quillChange}
                    section={this.props.section}
                    updateUploadArray={this.updateUploadArray}
                    placeholder={
                      this.props.section.defaultText === "<div></div>" ||
                      this.props.section.defaultText === ""
                        ? "Click here to add some content to this section"
                        : ""
                    }
                  />
                </div>
              ) : (
                <KpsEditor
                  focusOnMount
                  newPdf={this.newUploadId}
                  onChange={this.quillChange}
                  // initialContent={this.state.initialContent}
                  initialContent={this.props.section.defaultText}
                  updateUploadArray={this.updateUploadArray}
                />
              )}
            </div>
          ) : (
            <>
              {this.state.edit ? (
                <EditDecisionTree
                  edit={this.state.edit}
                  onChangeSection={(section) => {
                    this.updateSection(section);
                  }}
                  update={(section) => {
                    this.updateSection(section);
                    this.setUnsaved(false, section.sectionID);
                    this.setState({ edit: false });
                  }}
                  openEdit={() => {
                    this.setState({ edit: false });
                    this.props.setEditId(null);
                  }}
                  section={this.props.section}
                />
              ) : (
                <DisplayDecisionTree
                  editable={this.props.section.canBeEdited}
                  openEdit={this.openEdit}
                  isSection
                  node={JSON.parse(this.props.section.defaultText)}
                  setIncomplete={(incomplete) => {
                    this.setState({ incomplete: incomplete });
                    this.props.setIncomplete(incomplete, this.props.section);
                  }}
                />
              )}
            </>
          )}
          {/* <EditDecisionTree
            edit={this.state.edit}
            update={(section) => {
              this.props.updateSection(section);
              this.setState({ edit: false });
            }}
            openEdit={() => this.setState({ edit: false })}
            section={this.props.section}
          />  */}
        </CardContent>
        {this.state.editing ? (
          <DialogActions>
            <Button onClick={this.cancelEdit}>
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              style={{ border: this.state.unsaved ? "2px dotted red" : "" }}
              onClick={this.acceptChange}
              id="section-ok"
            >
              <Trans i18nKey="global_ok" />
            </Button>
          </DialogActions>
        ) : null}
      </div>
    );
  }
  startEdit = () => {
    this.suppressFor_ms(2000);
    !this.props.section.reusableSectionId && !this.props.section.reusableSection  &&
      this.props.section.canBeEdited &&
      this.setState({
        editing: true,
        prevText: this.props.section.defaultText,
      });
  };
  updateUploadArray = (array) => {
    let attachments = [];
    if (typeof array === "number") {
      attachments.push(array);
    } else if (Array.isArray(array)) {
      attachments = array;
    }
    this.setState({ attachmentIds: attachments });
    let section = { ...this.props.section };
    section.attachmentIds = attachments;
    this.props.updateSection(section);
  };
  openEdit = () => {
    this.setState({ edit: true }, () =>
      this.props.setEditId(
        this.state.edit ? this.props.section.id : null,
        this.props.section.sectionColumn
      )
    );
    // this.props.setEditId(this.props.section.id);
  };
  editSection = (section) => {
    console.log(section);
  };
  newUploadId = (response) => {
    if (this.state.attachmentIds.indexOf(Number(response)) === -1) {
      let attachments = this.state.attachmentIds.splice(0);
      attachments.push(Number(response));
      this.setState({ attachmentIds: attachments });
      let section = { ...this.props.section };
      section.attachmentIds = attachments;
      // this.props.updateSection(section);
    }
  };
  quillChange = (text) => {
    this.setState({ tempText: text });
    let section = {
      ...this.props.section,
      defaultText: text,
      attachmentIds: this.state.attachmentIds,
    };
    this.updateSection(section);
  };
  cancelEdit = () => {
    this.setState({ editing: false, initialContent: this.state.prevText });
    this.quillChange(this.state.prevText);
    if(!this.props.section.reusableSectionId){
      this.setUnsaved(false, this.props.section.sectionID);
    }
  };
  acceptChange = () => {
    this.setState({ editing: false, initialContent: this.state.tempText });
    this.quillChange(this.state.tempText);
    if(!this.props.section.reusableSectionId){
      this.setUnsaved(false, this.props.section.sectionID);
    }
  };
  updateName = (title) => {
    this.setState({
      section: { ...this.state.section, name: title.target.value },
    });
  };
}
export default withStyles(styles)(ContentSection);
